<template>
  <router-view></router-view>
</template>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');
html, body {
  font-family: 'Roboto', sans-serif;
}

#app {
  font-family: 'Roboto', sans-serif;
}
</style>

<script>

export default {
  title: 'iPaymu System Status',
  name: 'App',
}
</script>